import { encode } from "js-base64";

const getUrlScheme = (data: string) => {
  return `vppal://${data}`;
};

export const getLoginUrlScheme = (uuid: string) => {
  return getUrlScheme(encode(`login?v=${uuid}`));
};
